// Test IDs — Tanow family care app.
export const APP = {
    demoBanner: 'app-demo-banner',
    sidebar: 'app-sidebar',
    userMenu: 'app-user-menu',
    logoutButton: 'app-logout-button',
    navDashboard: 'nav-dashboard',
    navFacilities: 'nav-households',
    navPatients: 'nav-members',
    navSurveys: 'nav-check-ins',
    navAssignments: 'nav-sent-check-ins',
    navDoctors: 'nav-doctors',
    searchTrigger: 'app-search-trigger',
    searchInput: 'app-search-input',
    searchResult: 'app-search-result',
};

export const AUTH_PAGE = { googleButton: 'login-google-button' };

export const DASHBOARD = {
    root: 'dashboard-root',
    statOpenLoops: 'stat-waiting',
    statOpenTasks: 'stat-todos',
    statFlagged: 'stat-attention',
    statAppointments: 'stat-upcoming',
    triageList: 'attention-list',
    upcomingList: 'upcoming-list',
    reviewButton: 'attention-review-button',
    reviewNote: 'attention-review-note',
    reviewSubmit: 'attention-review-submit',
    householdsGrid: 'dashboard-households',
    seedDemoButton: 'dashboard-seed-demo',
};

export const FACILITIES = {
    root: 'households-root',
    addButton: 'household-add-button',
    nameInput: 'household-name-input',
    kindInput: 'household-kind-input',
    submit: 'household-submit',
    card: 'household-card',
    openLink: 'household-open-link',
    editButton: 'household-edit-button',
    deleteButton: 'household-delete-button',
};

export const FACILITY_DETAIL = {
    root: 'household-detail-root',
    addPatientButton: 'household-add-member-button',
    patientCard: 'household-member-card',
    openPatient: 'household-open-member',
    patientNameInput: 'member-name-input',
    patientDobInput: 'member-dob-input',
    patientPhoneInput: 'member-phone-input',
    patientEmailInput: 'member-email-input',
    patientAllergiesInput: 'member-allergies-input',
    patientConditionsInput: 'member-conditions-input',
    patientSubmit: 'member-submit',
    manageCoordinators: 'household-manage-coordinators',
    coordinatorRow: 'household-coordinator-row',
    invitedRow: 'household-invited-row',
    coordinatorEmailInput: 'household-coordinator-email',
    coordinatorInvite: 'household-coordinator-invite',
    coordinatorRemove: 'household-coordinator-remove',
    editHousehold: 'household-edit',
    deleteHousehold: 'household-delete',
    memberEdit: 'member-edit',
    memberDelete: 'member-delete',
};

export const PATIENT = {
    root: 'member-root',
    allergyBanner: 'member-allergy-banner',
    tabLog: 'member-tab-notes',
    tabMeds: 'member-tab-meds',
    tabLabs: 'member-tab-labs',
    tabAppointments: 'member-tab-appointments',
    tabSurveys: 'member-tab-check-ins',
    tabVitals: 'member-tab-vitals',
    readingRow: 'member-reading-row',
    addReading: 'member-add-reading',
    readingType: 'member-reading-type',
    readingValue: 'member-reading-value',
    readingSystolic: 'member-reading-systolic',
    readingDiastolic: 'member-reading-diastolic',
    readingSubmit: 'member-reading-submit',
    readingDelete: 'member-reading-delete',
    logForm: 'member-note-form',
    logNote: 'member-note-note',
    logType: 'member-note-type',
    logStatus: 'member-note-status',
    logAttention: 'member-note-attention',
    logCreateTask: 'member-note-create-task',
    logTaskTitle: 'member-note-task-title',
    logTaskDue: 'member-note-task-due',
    logSubmit: 'member-note-submit',
    logEntry: 'member-note-entry',
    logEdit: 'member-note-edit',
    logDelete: 'member-note-delete',
    // Meds
    medAdd: 'member-med-add',
    medName: 'member-med-name',
    medDose: 'member-med-dose',
    medRefill: 'member-med-refill',
    medSubmit: 'member-med-submit',
    medDiscontinue: 'member-med-stop',
    medEdit: 'member-med-edit',
    medDelete: 'member-med-delete',
    // Labs
    labAdd: 'member-lab-add',
    labTest: 'member-lab-test',
    labValue: 'member-lab-value',
    labUnit: 'member-lab-unit',
    labRefLow: 'member-lab-ref-low',
    labRefHigh: 'member-lab-ref-high',
    labDate: 'member-lab-date',
    labSubmit: 'member-lab-submit',
    labEdit: 'member-lab-edit',
    labDelete: 'member-lab-delete',
    labViewChart: 'member-lab-view-chart',
    labViewTable: 'member-lab-view-table',
    labFilter: 'member-lab-filter',
    labTestPicker: 'member-lab-test-picker',
    labNewTestName: 'member-lab-new-test-name',
    labNewTestUnit: 'member-lab-new-test-unit',
    labNewTestLow: 'member-lab-new-test-low',
    labNewTestHigh: 'member-lab-new-test-high',
    labNewTestSave: 'member-lab-new-test-save',
    // Appointments
    apptAdd: 'member-appt-add',
    apptTitle: 'member-appt-title',
    apptProvider: 'member-appt-provider',
    apptDate: 'member-appt-date',
    apptStatus: 'member-appt-status',
    apptSubmit: 'member-appt-submit',
    apptEdit: 'member-appt-edit',
    apptDelete: 'member-appt-delete',
    apptPrep: 'member-appt-prep',
    // Check-ins
    sendSurvey: 'member-send-check-in',
    sendSurveySubmit: 'member-send-check-in-submit',
    assignmentLink: 'member-assignment-link',
    smsPhoneInput: 'send-checkin-sms-phone',
    smsSendButton: 'send-checkin-sms-send',
    smsWarning: 'send-checkin-sms-warning',
    smsStatus: 'send-checkin-sms-status',
    // Export & profile actions
    exportPdf: 'member-export-pdf',
    exportRange: 'member-export-range',
    memberEdit: 'member-edit-button',
    memberDelete: 'member-delete-button',
};

export const SURVEYS = {
    root: 'check-ins-root',
    addButton: 'check-in-add-button',
    nameInput: 'check-in-name-input',
    descInput: 'check-in-desc-input',
    submit: 'check-in-submit',
    card: 'check-in-card',
    editLink: 'check-in-edit-link',
    deleteButton: 'check-in-delete-button',
};

export const SURVEY_EDITOR = {
    root: 'check-in-editor-root',
    addStep: 'check-in-editor-add-step',
    save: 'check-in-editor-save',
    stepKind: 'check-in-editor-step-kind',
    stepPrompt: 'check-in-editor-step-prompt',
    stepQType: 'check-in-editor-step-qtype',
    stepFlagOp: 'check-in-editor-step-flag-op',
    stepFlagValue: 'check-in-editor-step-flag-value',
    stepChoices: 'check-in-editor-step-choices',
    stepUnitLabel: 'check-in-editor-step-unit',
    stepNumberMin: 'check-in-editor-step-number-min',
    stepNumberMax: 'check-in-editor-step-number-max',
    stepBpTagToggle: 'check-in-editor-step-bp-tag',
    removeStep: 'check-in-editor-remove-step',
};

export const ASSIGNMENTS = {
    root: 'sent-check-ins-root',
    row: 'sent-check-in-row',
    open: 'sent-check-in-copy',
    delete: 'sent-check-in-delete',
};

export const PUBLIC_SURVEY = {
    root: 'public-check-in-root',
    startButton: 'public-check-in-start',
    nextButton: 'public-check-in-next',
    prevButton: 'public-check-in-prev',
    submitButton: 'public-check-in-submit',
    answerYes: 'public-check-in-answer-yes',
    answerNo: 'public-check-in-answer-no',
    scaleValue: 'public-check-in-scale-value',
    freeTextInput: 'public-check-in-freetext',
    numberInput: 'public-check-in-number',
    bpSystolicInput: 'public-check-in-bp-systolic',
    bpDiastolicInput: 'public-check-in-bp-diastolic',
    bpError: 'public-check-in-bp-error',
    choiceOption: 'public-check-in-choice',
    thankYou: 'public-check-in-thankyou',
};

export const LAB_TESTS_SETTINGS = {
    root: 'lab-tests-root',
    addButton: 'lab-tests-add',
    nameInput: 'lab-tests-name',
    unitInput: 'lab-tests-unit',
    lowInput: 'lab-tests-low',
    highInput: 'lab-tests-high',
    textInput: 'lab-tests-text',
    submit: 'lab-tests-submit',
    row: 'lab-tests-row',
    edit: 'lab-tests-edit',
    delete: 'lab-tests-delete',
};

export const PREP = {
    root: 'prep-sheet-root',
    printButton: 'prep-sheet-print',
    addQuestionInput: 'prep-sheet-add-question-input',
    addQuestionSubmit: 'prep-sheet-add-question-submit',
    question: 'prep-sheet-question',
    questionCheck: 'prep-sheet-question-check',
    questionRemove: 'prep-sheet-question-remove',
};
